var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.921 53.341a6.928 6.928 0 0 0-9.787 0L66.2 62.273a6.924 6.924 0 0 0-6.842-5.938H41.907a13.645 13.645 0 0 0-8.928 3.327L26.1 65.613l-1.961-3.154-11.652 7.249L26.8 92.728l11.655-7.249L37 83.13h19.091a21.167 21.167 0 0 0 15.068-6.241l13.762-13.762a6.929 6.929 0 0 0 0-9.786ZM27.767 88.6 16.618 70.671l6.56-4.08 11.148 17.926ZM82.8 61.006 69.038 74.768a18.189 18.189 0 0 1-12.947 5.362H35.132l-7.426-11.938 7.235-6.261a10.65 10.65 0 0 1 6.966-2.6h17.452a3.92 3.92 0 0 1 0 7.84H48.484v3h10.875a6.936 6.936 0 0 0 .906-.066v.066a5.528 5.528 0 0 0 3.886-1.61l13.1-13.1a3.921 3.921 0 1 1 5.549 5.545ZM50 46.254a19.208 19.208 0 1 0-19.208-19.208A19.23 19.23 0 0 0 50 46.254Zm0-35.416a16.208 16.208 0 1 1-16.208 16.208A16.226 16.226 0 0 1 50 10.838Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.562 31.154a1.5 1.5 0 0 0 1.561-.119l7.575-5.46a1.5 1.5 0 1 0-1.754-2.433l-5.2 3.746v-9.841a1.5 1.5 0 0 0-3 0v12.771a1.5 1.5 0 0 0 .818 1.336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTime);
export default __webpack_public_path__ + "static/media/save-time.351f69f8b9f995811f8d72308e944954.svg";
export { ForwardRef as ReactComponent };